// extracted by mini-css-extract-plugin
module.exports = {"formClass":"so","setupPinButton":"sp","submitButton":"sq","cancelButton":"sr","enterPinHelpText":"ss"};